import { FC } from "react";
import { Redeem } from "@mui/icons-material";

import { useMetamask, useWriteContractWithSimulation } from "@dzambalaorg/react-hooks-eth";
import { ListAction, ListActionVariant } from "@framework/styled";
import { AddressType, type ILotteryToken, TokenStatus } from "@framework/types";
import LotteryGetPrizeABI from "@framework/abis/json/LotteryRandom/getPrize.json";

import { decodeNumbersToArr, getWinners } from "../../../../../pages/mechanics/gambling/lottery/token-list/utils";

export interface ILotteryRewardButtonProps {
  className?: string;
  disabled?: boolean;
  token: ILotteryToken;
  variant?: ListActionVariant;
}

export const LotteryRewardButton: FC<ILotteryRewardButtonProps> = props => {
  const { className, disabled, token, variant } = props;

  const { writeContractAsync } = useWriteContractWithSimulation();

  const { execute: metaFn } = useMetamask(async (ticket: ILotteryToken) => {
    return writeContractAsync({
      address: token.round.contract!.address as AddressType,
      abi: LotteryGetPrizeABI,
      functionName: "getPrize",
      args: [ticket.tokenId, token.round.roundId],
    });
  });

  const handleReward = (ticket: ILotteryToken): (() => Promise<void>) => {
    return async () => {
      return metaFn(ticket).then(() => {
        // TODO reload page
      });
    };
  };

  const count = getWinners(decodeNumbersToArr(token.metadata.NUMBERS), token.round.numbers || []);
  if (token.metadata.PRIZE === "1") {
    return null;
  }

  return (
    <ListAction
      onClick={handleReward(token)}
      icon={Redeem}
      message="form.tips.redeem"
      className={className}
      dataTestId="LotteryRewardButton"
      disabled={disabled || count === "" || token.tokenStatus !== TokenStatus.MINTED}
      variant={variant}
    />
  );
};
